import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_AngerAdultAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_AngerAdultAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <h3 className="text-center">LEVEL 2-Anger-Adult</h3>
                <p className="text-center">
                    *PROMIS Emotional Distress-Anger-Short Form
                </p>
                <p>
                    <span className="eleHeader">If the measure is being completed by an informant, what is your relationship with the individual receiving care?</span>

                    <input type="text" id="txtRelationship" name="txtRelationship" className="add-only" />
                </p>
                <p>
                    <span className="eleHeader">In a typical week, approximately how much time do you spend with the individual receiving care?</span>
                    <input type="text" id="txtIndividualReceivingCare" name="txtIndividualReceivingCare" className="add-only w-250" /> hours/week
                </p>

                <p>
                    <b>Instructions:</b> On the DSM-5 Level 1 cross-cutting questionnaire that you just completed, you indicated that during the past 2
                    weeks you (the individual receiving care) have been bothered by "feeling irritated, grouchy, or angry" at a mild or greater level of
                    severity. The questions below ask about these feelings in more detail and especially how often you (the individual receiving care)
                    have been bothered by a list of symptoms during the past 7 days. Please respond to each item by marking (&#10003; or x) one box per
                    row.

                </p>

                <table>
                    <tr>
                        <td className="w-750"><b>Clinician Use</b></td>

                    </tr>
                    <tr>
                        <td className="w-325"><span className="eleHeader">In the past SEVEN (7) DAYS....</span></td>
                        <td className="w-50"><span className="eleHeader">Never</span></td>
                        <td className="w-60"><span className="eleHeader">Rarely</span></td>
                        <td className="w-90"><span className="eleHeader">Sometimes</span></td>
                        <td className="w-50"><span className="eleHeader">Often</span></td>
                        <td className="w-60"><span className="eleHeader">Always</span></td>
                        <td className="w-115"><span className="eleHeader">Item Score</span></td>

                    </tr>

                    <tr>
                        <td className="w-325"><b>(1)</b> I was irritated more than people knew.</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbIrritatedNever" name="rbIrritated" className="add-only" value="Never" /> 1</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbIrritatedRarely" name="rbIrritated" className="add-only" value="Rarely" /> 2</td>
                        <td className="w-90 text-center">
                            <input type="radio" id="rbIrritatedSometimes" name="rbIrritated" className="add-only" value="Sometimes" /> 3</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbIrritatedOften" name="rbIrritated" className="add-only" value="Often" /> 4</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbIrritatedAlways" name="rbIrritated" className="add-only" value="Always" /> 5</td>
                        <td className="w-115 text-center">
                            <input type="text" id="txtItemScore_Irritated" name="txtItemScore_Irritated" className="add-only" />
                        </td>
                    </tr>

                    <tr>
                        <td className="w-325"><b>(2)</b> I felt angry.</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbAngryNever" name="rbAngry" className="add-only" value="Never" /> 1</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbAngryRarely" name="rbAngry" className="add-only" value="Rarely" /> 2</td>
                        <td className="w-90 text-center">
                            <input type="radio" id="rbAngrySometimes" name="rbAngry" className="add-only" value="Sometimes" /> 3</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbAngryOften" name="rbAngry" className="add-only" value="Often" /> 4</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbAngryAlways" name="rbAngry" className="add-only" value="Always" /> 5</td>
                        <td className="w-115 text-center">
                            <input type="text" id="txtItemScore_Angry" name="txtItemScore_Angry" className="add-only" />
                        </td>
                    </tr>

                    <tr>
                        <td className="w-325"><b>(3)</b> I felt like I was ready to explode.</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbReadyToExplodeNever" name="rbReadyToExplode" className="add-only" value="Never" /> 1</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbReadyToExplodeRarely" name="rbReadyToExplode" className="add-only" value="Rarely" /> 2</td>
                        <td className="w-90 text-center">
                            <input type="radio" id="rbReadyToExplodeSometimes" name="rbReadyToExplode" className="add-only" value="Sometimes" /> 3</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbReadyToExplodeOften" name="rbReadyToExplode" className="add-only" value="Often" /> 4</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbReadyToExplodeAlways" name="rbReadyToExplode" className="add-only" value="Always" /> 5</td>
                        <td className="w-115 text-center">
                            <input type="text" id="txtItemScore_ReadyToExplode" name="txtItemScore_ReadyToExplode" className="add-only" />
                        </td>
                    </tr>

                    <tr>
                        <td className="w-325"><b>(4)</b> I was grouchy.</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbGrouchyNever" name="rbGrouchy" className="add-only" value="Never" /> 1</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbGrouchyRarely" name="rbGrouchy" className="add-only" value="Rarely" /> 2</td>
                        <td className="w-90 text-center">
                            <input type="radio" id="rbGrouchySometimes" name="rbGrouchy" className="add-only" value="Sometimes" /> 3</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbGrouchyOften" name="rbGrouchy" className="add-only" value="Often" /> 4</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbGrouchyAlways" name="rbGrouchy" className="add-only" value="Always" /> 5</td>
                        <td className="w-115 text-center">
                            <input type="text" id="txtItemScore_Grouchy" name="txtItemScore_Grouchy" className="add-only" />
                        </td>
                    </tr>

                    <tr>
                        <td className="w-325"><b>(5)</b> I felt annoyed.</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbAnnoyedNever" name="rbAnnoyed" className="add-only" value="Never" /> 1</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbAnnoyedRarely" name="rbAnnoyed" className="add-only" value="Rarely" /> 2</td>
                        <td className="w-90 text-center">
                            <input type="radio" id="rbAnnoyedSometimes" name="rbAnnoyed" className="add-only" value="Sometimes" /> 3</td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbAnnoyedOften" name="rbAnnoyed" className="add-only" value="Often" /> 4</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbAnnoyedAlways" name="rbAnnoyed" className="add-only" value="Always" /> 5</td>
                        <td className="w-115 text-center">
                            <input type="text" id="txtItemScore_Annoyed" name="txtItemScore_Annoyed" className="add-only" />
                        </td>
                    </tr>

                    <tr>
                        <td className="w-650 text-right"><b>Total/Partial Raw Score:</b></td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtPartialRawScore" name="txtPartialRawScore" className="add-only" />
                        </td>
                    </tr>

                    <tr>
                        <td className="w-650 text-right"><b>Prorated Total Raw Score:</b></td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtProratedTotalRawScore" name="txtProratedTotalRawScore" className="add-only" />
                        </td>
                    </tr>

                    <tr>
                        <td className="w-650 text-right"><b>T-Score:</b></td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtT_Score" name="txtT_Score" className="add-only" />
                        </td>
                    </tr>



                </table>


                <p>
                    <span className="eleHeader">Instructions to Clinicians</span>
                    The DSM-5 Level 2-Anger-Adult measure is a 5-item version of the PROMIS Anger Short Form that assesses the pure
                    domain of anger in individuals age 18 and older. The measure is completed by the individual prior to a visit with the clinician.
                    If the individual receiving care is of impaired capacity and unable to complete the form (e.g., an individual with dementia), a
                    knowledgeable informant may complete the measure as done in the DSM-5 Field Trials. However, the PROMIS Anger Short
                    Form has not been validated as an informant report scale by the PROMIS group. Each item asks the individual receiving care
                    (or informant) to rate the severity of the individual's anger <b>during the past 7 days</b>.

                </p>
                <p>
                    <span className="eleHeader">Scoring and Interpretation</span>
                    Each item on the measure is rated on a 5-point scale (1=never; 2=rarely; 3=sometimes; 4=often; and 5=always) with a range
                    in score from 5 to 25 with higher scores indicating greater severity of anger. The clinician is asked to review the score on each
                    item on the measure during the clinical interview and indicate the raw score for each
                    item in the section provided for "Clinician Use." The raw scores on the 5 items should
                    be summed to obtain a total raw score. Next, the T-score table should be used to
                    identify the T-score associated with the individual's total raw score and the
                    information entered in the T-score row on the measure.
                </p>
                <p>
                    <b>Note:</b> This look-up table works only if all items on the form are answered. If 75% or
                    more of the questions have been answered; you are asked to prorate the raw score
                    and then look up the conversion to T-Score. The formula to prorate the partial raw
                    score to Total Raw Score is:
                </p>
                <p>
                    <b>(Raw sum x number of items on the short form) / (Number of items that were actually answered)</b>
                </p>

                <table>
                    <tr>
                        <td className="w-125 text-center"><span className="eleHeader">Raw Score</span></td>
                        <td className="w-125 text-center"><span className="eleHeader">T-Score</span></td>
                        <td className="w-125 text-center"><span className="eleHeader">SE</span></td>
                        <td className="w-125 text-center"><span className="eleHeader">Raw Score</span></td>
                        <td className="w-125 text-center"><span className="eleHeader">T-Score</span></td>
                        <td className="w-125 text-center"><span className="eleHeader">SE</span></td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">5  </td>
                        <td className="w-125 text-center">32.9 </td>
                        <td className="w-125 text-center">5.3 </td>
                        <td className="w-125 text-center">15  </td>
                        <td className="w-125 text-center">58.8  </td>
                        <td className="w-125 text-center">3.2 </td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">6  </td>
                        <td className="w-125 text-center">38.1 </td>
                        <td className="w-125 text-center">4 </td>
                        <td className="w-125 text-center">16  </td>
                        <td className="w-125 text-center">60.8  </td>
                        <td className="w-125 text-center">3.2 </td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">7  </td>
                        <td className="w-125 text-center">41.3 </td>
                        <td className="w-125 text-center">3.7 </td>
                        <td className="w-125 text-center">17  </td>
                        <td className="w-125 text-center">62.9 </td>
                        <td className="w-125 text-center">3.2 </td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">8  </td>
                        <td className="w-125 text-center">44  </td>
                        <td className="w-125 text-center">3.5 </td>
                        <td className="w-125 text-center">18  </td>
                        <td className="w-125 text-center">65  </td>
                        <td className="w-125 text-center">3.2 </td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">9  </td>
                        <td className="w-125 text-center">46.3  </td>
                        <td className="w-125 text-center">3.4 </td>
                        <td className="w-125 text-center">19 </td>
                        <td className="w-125 text-center">67.2 </td>
                        <td className="w-125 text-center">3.2</td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">10  </td>
                        <td className="w-125 text-center">48.4  </td>
                        <td className="w-125 text-center">3.3 </td>
                        <td className="w-125 text-center">20  </td>
                        <td className="w-125 text-center">69.4  </td>
                        <td className="w-125 text-center">3.3 </td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">11  </td>
                        <td className="w-125 text-center">50.5  </td>
                        <td className="w-125 text-center">3.3 </td>
                        <td className="w-125 text-center">21  </td>
                        <td className="w-125 text-center">71.7 </td>
                        <td className="w-125 text-center">3.3 </td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">12  </td>
                        <td className="w-125 text-center">52.6 </td>
                        <td className="w-125 text-center">3.2 </td>
                        <td className="w-125 text-center">22  </td>
                        <td className="w-125 text-center">74.1 </td>
                        <td className="w-125 text-center">3.3 </td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">13  </td>
                        <td className="w-125 text-center">54.7 </td>
                        <td className="w-125 text-center">3.2 </td>
                        <td className="w-125 text-center">23  </td>
                        <td className="w-125 text-center">76.8  </td>
                        <td className="w-125 text-center">3.4 </td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center">14  </td>
                        <td className="w-125 text-center">56.7  </td>
                        <td className="w-125 text-center">3.2 </td>
                        <td className="w-125 text-center">24  </td>
                        <td className="w-125 text-center">79.7  </td>
                        <td className="w-125 text-center">3.5 </td>
                    </tr>
                    <tr>
                        <td className="w-125 text-center"></td>
                        <td className="w-125 text-center"></td>
                        <td className="w-125 text-center"></td>
                        <td className="w-125 text-center">25  </td>
                        <td className="w-125 text-center">83.3  </td>
                        <td className="w-125 text-center">3.9 </td>
                    </tr>
                </table>
                <p>
                    If the result is a fraction, round to the nearest whole number. For example, if 4 of 5
                    items were answered and the sum of those 4 responses was 15, the prorated raw
                    score would be 15 X 5/4 = 18.75. The T-score in this example would be that T-score
                    associated with the rounded whole number raw score (in this case 19, for a T-score of
                    67.2).
                </p>
                <p>
                    The T-scores are interpreted as follows:
                </p>
                <ul>
                    <li>Less than 55 = None to slight</li>
                    <li>55.0-59.9 = Mild</li>
                    <li>60.0-69.9 = Moderate</li>
                    <li>70 and over = Severe</li>
                </ul>
                <p>
                    <b>Note:</b>
                    If more than 25% of the total items on the measure are missing the scores
                    should not be used. Therefore, the individual receiving care (or informant) should be
                    encouraged to complete all of the items on the measure.
                </p>

                <p>
                    <span className="eleHeader">Frequency of Use</span>


                    To track change in the severity of the individual's anger over time, the measure may be completed at regular intervals as
                    clinically indicated, depending on the stability of the individual's symptoms and treatment status. For individuals with
                    impaired capacity, it is preferred that completion of the measures at follow-up appointments is by the same knowledgeable
                    informant. Consistently high scores on a particular domain may indicate significant and problematic areas for the individual
                    that might warrant further assessment, treatment, and follow-up. Your clinical judgment should guide your decision.
                </p>
            </div>
        </form>
    )
}